import React, { ReactElement } from 'react'
import { CallUs } from './CallUs'
import { schema } from './schema'

export default (): ReactElement => <CallUs schema={schema} />
